import * as React from 'react';

import './ModelsLoading.scss';

const ModelsLoading = () => {
  return (
    <div className="rp-models-loading">
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
      <div className="rp-models-loading-bar" />
    </div>
  );
};

export default ModelsLoading;
